/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FC } from 'react'
import Animated, { FadeInUp, FadeOutUp, Keyframe } from 'react-native-reanimated'
import { styled } from 'styled-components/native'

import { TouchableOpacity } from 'ui/components/TouchableOpacity'
import { SnackBarProps, SnackBarType } from 'ui/designSystem/Snackbar/SnackBar'
import { CloseFilled } from 'ui/svg/icons/CloseFilled'
import { AccessibleIcon } from 'ui/svg/icons/types'
import { Typo } from 'ui/theme'

export const SnackBarDefault: FC<SnackBarProps & { Icon: FC<AccessibleIcon> }> = ({
  label,
  onClose,
  type,
  animationDuration,
  Icon,
}) => {
  return (
    <SnackbarContainer testID={`snackbar-${type}`} entering={FadeInUp} exiting={FadeOutUp}>
      <SnackBarContent type={type}>
        <Icon />
        <LabelContainer>
          <Label>{label}</Label>
        </LabelContainer>
        <TouchableOpacity onPress={onClose}>
          <Close />
        </TouchableOpacity>
      </SnackBarContent>
      <ProgressBar
        type={type}
        entering={new Keyframe({
          from: { transform: [{ scaleX: 0 }] },
          to: { transform: [{ scaleX: 1 }] },
        }).duration(animationDuration)}
      />
    </SnackbarContainer>
  )
}

const SnackbarContainer = styled(Animated.View)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  marginBottom: theme.designSystem.size.spacing.xs,
}))

const LabelContainer = styled.View({
  flex: 1,
})

const ProgressBar = styled(Animated.View)<{ type: SnackBarType }>(({ theme, type }) => ({
  width: '100%',
  backgroundColor: theme.designSystem.color.icon[type],
  height: theme.designSystem.size.spacing.xs,
  borderBottomLeftRadius: theme.designSystem.size.spacing.xs,
  borderBottomRightRadius: theme.designSystem.size.spacing.xs,
  transformOrigin: 'left',
}))

const SnackBarContent = styled.View<{ type: SnackBarType }>(({ theme, type }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.designSystem.size.spacing.s,
  backgroundColor: theme.designSystem.color.background[type],
  padding: theme.designSystem.size.spacing.l,
}))

const Label = styled(Typo.BodyAccentS)({
  flex: 1,
})

const Close = styled(CloseFilled).attrs(({ theme }) => ({
  size: theme.icons.sizes.smaller,
}))``
